export const PersonDescriptionTypeNameSet = new Set([
    'PersonName',
    'ProfileImage',
    'PersonStatus',
    'PersonImage',
    'SignKey',
    'EncryptionKey',
    'OrganisationName',
    'Birthday',
    'JobTitle',
    'Company',
    'Notes'
]);
/**
 * Checks if the description is of a specific description type.
 *
 * @param description
 * @param type
 */
export function isDescriptionOfType(description, type) {
    return description.$type$ === type;
}
// #### Recipes ####
export const PersonNameRecipe = {
    $type$: 'Recipe',
    name: 'PersonName',
    rule: [
        {
            itemprop: 'name',
            itemtype: { type: 'string' }
        }
    ]
};
export const PersonStatusRecipe = {
    $type$: 'Recipe',
    name: 'PersonStatus',
    rule: [
        {
            itemprop: 'value',
            itemtype: { type: 'string' }
        },
        {
            itemprop: 'timestamp',
            itemtype: { type: 'number' }
        },
        {
            itemprop: 'location',
            itemtype: { type: 'string' }
        }
    ]
};
export const PersonImageRecipe = {
    $type$: 'Recipe',
    name: 'PersonImage',
    rule: [
        {
            itemprop: 'image',
            itemtype: { type: 'referenceToBlob' }
        },
        {
            itemprop: 'timestamp',
            itemtype: { type: 'number' }
        },
        {
            itemprop: 'location',
            itemtype: { type: 'string' }
        }
    ]
};
export const ProfileImageRecipe = {
    $type$: 'Recipe',
    name: 'ProfileImage',
    rule: [
        {
            itemprop: 'image',
            itemtype: { type: 'referenceToBlob' }
        }
    ]
};
export const SignKeyRecipe = {
    $type$: 'Recipe',
    name: 'SignKey',
    rule: [
        {
            itemprop: 'key',
            itemtype: { type: 'string', regexp: /^[A-Za-z0-9+/]{64}$/ }
        }
    ]
};
export const EncryptionKeyRecipe = {
    $type$: 'Recipe',
    name: 'EncryptionKey',
    rule: [
        {
            itemprop: 'key',
            itemtype: { type: 'string', regexp: /^[A-Za-z0-9+/]{64}$/ }
        }
    ]
};
export const OrganisationNameRecipe = {
    $type$: 'Recipe',
    name: 'OrganisationName',
    rule: [
        {
            itemprop: 'name',
            itemtype: { type: 'string' }
        }
    ]
};
export const BirthdayRecipe = {
    $type$: 'Recipe',
    name: 'Birthday',
    rule: [
        {
            itemprop: 'date',
            itemtype: { type: 'string' }
        }
    ]
};
export const JobTitleRecipe = {
    $type$: 'Recipe',
    name: 'JobTitle',
    rule: [
        {
            itemprop: 'title',
            itemtype: { type: 'string' }
        }
    ]
};
export const CompanyRecipe = {
    $type$: 'Recipe',
    name: 'Company',
    rule: [
        {
            itemprop: 'name',
            itemtype: { type: 'string' }
        }
    ]
};
export const NotesRecipe = {
    $type$: 'Recipe',
    name: 'Notes',
    rule: [
        {
            itemprop: 'content',
            itemtype: { type: 'string' }
        }
    ]
};
export default [
    PersonNameRecipe,
    ProfileImageRecipe,
    PersonStatusRecipe,
    PersonImageRecipe,
    SignKeyRecipe,
    EncryptionKeyRecipe,
    OrganisationNameRecipe,
    BirthdayRecipe,
    JobTitleRecipe,
    CompanyRecipe,
    NotesRecipe
];
//# sourceMappingURL=PersonDescriptions.js.map